var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex recipient-footer"},[_c('div',{staticClass:"flex-grow-1"}),_c('b-button',{attrs:{"variant":"outline-danger mx-3"},on:{"click":function($event){return _vm.$router.push('/live-transplant')}}},[_vm._v("Close ")]),(_vm.isEdit)?[_c('b-button',{attrs:{"variant":"success","type":"submit"}},[_vm._v("Submit ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }